export default {
	// Number of categories in the game
	numberCategories: 0,

	// Number of questions per category
	category1Length: 0,
	category2Length: 0,
	category3Length: 0,
	category4Length: 0,
	category5Length: 0,
	category6Length: 0,

	// Category names
	categoryNames: {
		'category-1': '',
		'category-2': '',
		'category-3': '',
		'category-4': '',
		'category-5': '',
		'category-6': '',
	},

	//(Online [TRUE] or Local [FALSE])
	online: true,
	isViewOnly: false,
};
